<script lang="ts">
import { defineComponent, computed } from '@vue/composition-api';
import { useAppSlidePanelModule } from '@/store/global/appComponents/slidePanel';
import { OpenSlidePanel, CloseSlidePanel } from '@/store/global/appComponents/slidePanel/actions';

const SlidePanelContainer = defineComponent({
    name: 'SlidePanelContainer',
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setup(props, ctx) {
        const slidePanelStore = useAppSlidePanelModule();

        const isOpen = computed({
            get: () => slidePanelStore.state.isOpen,
            set: (val) => {
                const action = val ? new OpenSlidePanel() : new CloseSlidePanel();
                slidePanelStore.dispatch(action);
            },
        });

        return {
            isOpen,
        };
    },
});

export default SlidePanelContainer;
</script>

<template>
  <v-navigation-drawer
    v-model="isOpen"
    app
    clipped
    right
    width="350"
    disable-resize-watcher
  >
    <portal-target name="slidePanel" />
  </v-navigation-drawer>
</template>

<style lang="sass" scoped></style>
